(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("HCISystem", [], factory);
	else if(typeof exports === 'object')
		exports["HCISystem"] = factory();
	else
		root["HCISystem"] = factory();
})(window, function() {
return 